<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Opgeven wereldinkomen
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                De aanvullende gegevens kunnen nodig zijn voor:
                <ul>
                    <li>
                        het beoordelen van kwalificerende buitenlandse belastingplicht
                    </li>
                    <li>
                        de berekening van uw premie-inkomen
                    </li>
                    <li>
                        de berekening van uw drempelinkomen voor zorgkosten en giften
                    </li>
                    <li>
                        de uitbetaling van de algemene heffingskorting
                    </li>
                    <li>
                        de berekening van het arbeidsinkomen in verband met de arbeidskorting en de inkomensafhankelijke
                        combinatiekorting
                    </li>

                </ul>
            </div>
        </div>
    </div>

</div>

